import { APIModel } from "../api-model";
import { AssociatedUser } from "../associated-user";

export class TagCategory extends APIModel {
  id!: string;
  category_name!: string;
  category_identifier!: string;
  created_by!: AssociatedUser;
  updated_by!: AssociatedUser;
  disabled_by!: AssociatedUser;
  disabled_at!: string;
  disabled_by_id!: string;
  internal_reporting_display: string = 'combined_column';
  external_reporting_display: string = 'hidden';
  internal_reporting_label!: string;
  external_reporting_label!: string;

  static fieldsToMap = {
    direct: [
      'id',
      'category_name',
      'category_identifier',
      'disabled_at',
      'disabled_by_id',
      'internal_reporting_label',
      'external_reporting_label',
    ]
  }

  public toAPIPayload(): any {
    return {
      id: this.id,
      category_name: this.category_name,
      category_identifier: this.category_identifier,
      report_display_options: {
        internal_reporting_display: this.internal_reporting_display,
        external_reporting_display: this.external_reporting_display,
      }
    }
  }

  static buildFromAPI(record: any): TagCategory {
    const row = new TagCategory();
    record = record || {};

    this.mapFieldsDirectly<TagCategory>(TagCategory.fieldsToMap.direct, record, row);

    row.created_by = AssociatedUser.buildFromAPI(record.created_by);
    row.updated_by = AssociatedUser.buildFromAPI(record.updated_by);
    row.disabled_by = AssociatedUser.buildFromAPI(record.disabled_by);

    if (record.report_display_options) {
      row.internal_reporting_display = record.report_display_options.internal_reporting_display;
      row.external_reporting_display = record.report_display_options.external_reporting_display;
    }

    return row;
  }
}